'use strict';

var React = require('react');

var SvgSaveMinor = function SvgSaveMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 5v10h10v-8h-2v-2h2.5a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h3.293a1.5 1.5 0 0 1 1.06.44l1.708 1.706a1.5 1.5 0 0 1 .439 1.061v3.379l.793-.793a1 1 0 1 1 1.414 1.414l-2.5 2.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414l.793.793v-3.172l-1.414-1.414h-2.586z"
  }));
};

exports.SvgSaveMinor = SvgSaveMinor;
